export const fontNormal400 = { fontWeight: 400 };
export const fontNormal500 = { fontWeight: 500 };
export const fontNormal600 = { fontWeight: 600 };
export const fontBold700 = { fontWeight: 700 };
export const fontBold800 = { fontWeight: 800 };

export const screenSizes = {
  mb: 420,
  xs: 640,
  sm: 768,
  md: 1024,
  lg: 1200,
  xlg: 1368,
  xxlg: 1750,
  // breaking points from covideo v1 (c is for covideo)
  cmd: 812,
};

export const mediaQueryMinWidth = {
  mb: `@media (min-width: ${screenSizes.mb}px)`,
  xs: `@media (min-width: ${screenSizes.xs}px)`,
  sm: `@media (min-width: ${screenSizes.sm}px)`,
  md: `@media (min-width: ${screenSizes.md}px)`,
  lg: `@media (min-width: ${screenSizes.lg}px)`,
  xlg: `@media (min-width: ${screenSizes.xlg}px)`,
  xxlg: `@media (min-width: ${screenSizes.xxlg}px)`,
  // breaking points from covideo v1 (c is for covideo)
  cmd: `@media (min-width: ${screenSizes.cmd}px)`,
};

export const mediaQueryMaxWidth = {
  mb: `@media (max-width: ${screenSizes.mb}px)`,
  xs: `@media (max-width: ${screenSizes.xs}px)`,
  sm: `@media (max-width: ${screenSizes.sm}px)`,
  md: `@media (max-width: ${screenSizes.md}px)`,
  lg: `@media (max-width: ${screenSizes.lg}px)`,
  xlg: `@media (max-width: ${screenSizes.xlg}px)`,
  xxlg: `@media (max-width: ${screenSizes.xxlg}px)`,
  // breaking points from covideo v1 (c is for covideo)
  cmd: `@media (max-width: ${screenSizes.cmd}px)`,
};

export const palette = {
  themeDark: '#343A40',
  black_1_100: 'var(--black)',
  primaryDarkBlue: 'var(--primary)',
  covideoPrimaryColor: '#ff8b22',
  automotivePrimaryColor: " '#1C6ACF'",
  primaryColor10: 'rgb(28, 106, 207, 0.1)',
  buttonDanger: '#DC3545',
  buttonDangerHover: '#C82333',
  secondaryButtonBgColor: '#F2F4F6',

  // customColors
  black: '#000',
  white: '#fff',
  gray: '#f7f8fa',
  gray10: '#F6F7F9',

  gray20: '#EEEFF2',
  gray40: '#D0D3D9',
  gray60: '#9297A2',
  gray80: '#4E5461',
  gray100: '#272A32',

  lightgray: 'rgba(213,214,217,1)',

  blackRgba75: 'rgba(0,0,0, .75)',
  blue80: 'rgba(0, 27, 83, 0.8)',

  blue40: 'rgba(0, 27, 83, 0.4)',
  blue05: 'rgba(0, 27, 83, 0.05)',
  red100: '#E84C3D',
  green100: '#1EA45F',
  covideoBlue100: '#001B53',

  magic100: '#8D31D6',
  covideoGray60: 'rgba(146, 151, 162, 1)',
  covideoGray100: 'rgba(39, 42, 50, 1)',
  covideoGray40: 'rgba(208, 211, 217, 1)',
  error: 'rgba(232, 76, 61, 1)',
  transparent: 'transparent',
  whiteRgb75: 'rgba(255,255,255, .85)',
};

const covideoAutomotiveTheme = {
  colors: {
    navItemColor: palette.covideoBlue100,
    primaryColor5: 'rgb(28, 106, 207, 0.05)',
    primaryColor10: 'rgb(28, 106, 207, 0.1)',
    primaryColor80: 'rgb(28, 106, 207, 0.8)',
    primaryColor: '#1C6ACF',
    secondaryColor5: palette.blue05,
    secondaryColor: palette.covideoBlue100,
    primaryButtonTextColor: palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: palette.white,
  },
};
const covideoTheme = {
  colors: {
    navItemColor: palette.whiteRgb75,
    primaryColor5: 'rgba(255, 139, 34, 0.05)',
    primaryColor10: 'rgba(255, 139, 34, 0.1)',
    primaryColor80: 'rgba(255, 139, 34, 0.8)',
    primaryColor: '#ff8b22',
    secondaryColor5: 'rgba(255, 139, 34, 0.05)',
    secondaryColor: '#ff8b22',
    primaryButtonTextColor: palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: palette.primaryDarkBlue,
  },
};
export const mainTheme = {
  covideo: covideoTheme,
  automotive: covideoAutomotiveTheme,
};
